import { render, staticRenderFns } from "./PagePartnerPaymentSelectPlan.vue?vue&type=template&id=18a3d2ed"
import script from "./PagePartnerPaymentSelectPlan.vue?vue&type=script&lang=js"
export * from "./PagePartnerPaymentSelectPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports